'use client';

import styled from 'styled-components';

export const ScSliderLayoutContent = styled.div`
  background-color: ${({ theme }) => theme.blackColor};
  border-radius: 24px 24px 0px 0px;
  box-shadow:
    0px 0px 10px 8px rgba(0, 0, 0, 0.4),
    0px 0px 20px 8px rgba(0, 0, 0, 0.4);
  position: relative;
  z-index: 4;
`;

export const ScServerLayoutContainer = styled.div`
  transition: margin-top 0.3s;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
`;

export const ScClientLayoutContainer = styled.div<{
  $popupHeight: number;
}>`
  height: 100%;
  margin-top: ${({ $popupHeight }) =>
    $popupHeight > 0 ? `${$popupHeight}px` : 0};
  & > main {
    height: 100%;
  }
`;
